import Page from 'flarum/common/components/Page';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import app from 'flarum/forum/app';

export default class UnclePataLandingPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Uncle Pata');
    app.setTitleCount(0);
  }

  view() {
    const isLoggedIn = !!(app.session && app.session.user);

    return (
      <div className="QuantumSurfLandingPage">
        <section className="QuantumSurf-hero">
          <div className="QuantumSurf-hero-overlay"></div>
          <div className="QuantumSurf-hero-content">
            <div className="container">
              <div className="QuantumSurf-hero-text">
                <div className="QuantumSurf-badge">Fast Course Access</div>
                <h1 className="QuantumSurf-title">
                  Uncle Pata
                  <span className="QuantumSurf-subtitle-inline">Quick signup for course-uncle-pata</span>
                </h1>
                <p className="QuantumSurf-tagline">
                  Join the Uncle Pata course directly from this page and get enrolled into the matching course access group.
                </p>
                {!isLoggedIn && (
                  <button className="Button Button--primary QuantumSurf-cta" onclick={() => this.handleSignUp()}>
                    SIGN UP FOR THIS COURSE
                  </button>
                )}
                {isLoggedIn && (
                  <a href={app.route('courses')} className="Button Button--primary QuantumSurf-cta">
                    ACCESS YOUR COURSES
                  </a>
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="QuantumSurf-intro">
          <div className="container">
            <div className="QuantumSurf-intro-content">
              <p className="QuantumSurf-intro-greeting">
                <em>Welcome to the Uncle Pata fast signup page.</em>
              </p>
              <p className="QuantumSurf-intro-text">
                This page is intended to make local testing and enrollment easier by opening signup with the correct course enrollment key already attached.
              </p>
              <p className="QuantumSurf-intro-text">
                After signup, the user should be added to the course group that can view <strong>course-uncle-pata</strong>, and Phase B initialization should create progression rows for that course.
              </p>
            </div>
          </div>
        </section>

        <section className="QuantumSurf-curriculum">
          <div className="container">
            <h2 className="QuantumSurf-section-title">What this page does</h2>
            <div className="QuantumSurf-weeks">
              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Step 1</div>
                <h3 className="QuantumSurf-week-title">Open signup</h3>
                <p className="QuantumSurf-week-desc">The signup modal is opened with the course enrollment key prefilled in the request payload.</p>
              </div>
              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Step 2</div>
                <h3 className="QuantumSurf-week-title">Auto-enroll</h3>
                <p className="QuantumSurf-week-desc">The backend resolves the course group from the course tag permission and adds the new user to that group.</p>
              </div>
              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Step 3</div>
                <h3 className="QuantumSurf-week-title">Initialize progression</h3>
                <p className="QuantumSurf-week-desc">Phase B creates one row per module and unlocks only the first module for the new user.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  handleSignUp() {
    app.modal.show(SignUpModal, {
      courseEnrollmentKey: 'course-uncle-pata',
    });
  }
}
